/* ==========================================================================
   Schnellkauf in Produktkacheln — Hover-Variante
   Angelegt 15.09.2026.

   Legt die einzige Variante eines Produkts ohne Seitenwechsel in den Warenkorb
   und oeffnet die Warenkorb-Schublade. Faellt ohne JavaScript auf das normale
   Formular zurueck (der Browser sendet es dann klassisch ab).
   ========================================================================== */
(function () {
  'use strict';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsToRequest() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function showError(form, text) {
    var box = form.querySelector('.hc-quick-add__feedback');
    if (!box) return;
    box.textContent = text;
    box.classList.add('is-visible');
    window.setTimeout(function () {
      box.classList.remove('is-visible');
    }, 5000);
  }

  function submit(form) {
    if (form.classList.contains('is-loading')) return;

    var idField = form.querySelector('input[name="id"]');
    if (!idField || !idField.value) return;

    form.classList.add('is-loading');

    var body = new FormData();
    body.append('id', idField.value);
    body.append('quantity', '1');
    sectionsToRequest().forEach(function (id) {
      body.append('sections[]', id);
    });
    body.append('sections_url', window.location.pathname);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          // Shopify meldet einen Fehler, z. B. Bestand erschoepft.
          showError(form, state.description || state.message || 'Nicht verfügbar.');
          return;
        }

        var d = drawer();
        if (d && state.sections && typeof d.renderContents === 'function') {
          d.renderContents(state);
        } else {
          // Keine Schublade vorhanden: normaler Weg zum Warenkorb.
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function () {
        showError(form, 'Verbindung unterbrochen. Bitte erneut versuchen.');
      })
      .finally(function () {
        form.classList.remove('is-loading');
      });
  }

  /* Ein einziger Listener in der Capture-Phase erledigt beides: er faengt den
     Klick ab, bevor der ganzflaechige Kachel-Link ihn sieht, und loest selbst
     das Hinzufuegen aus.

     Wichtig: NICHT auf das submit-Ereignis warten. Ein stopPropagation in der
     Capture-Phase auf document verhindert, dass der Klick den Button erreicht,
     also wird das Formular nie abgesendet und ein submit-Listener feuert nie.
     Deshalb wird hier direkt gehandelt. */
  document.addEventListener(
    'click',
    function (event) {
      var form = event.target.closest('[data-hc-quick-add]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      submit(form);
    },
    true
  );

  /* Fallback fuer Tastaturbedienung und den Fall, dass das Formular aus einem
     anderen Grund klassisch abgesendet wird. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-hc-quick-add]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      submit(form);
    },
    true
  );
})();
